export default __webpack_public_path__ + "static/media/question-about.582f625a.png";